export const widgetDefaults = {
  pageName: 'booking_my_bookings_widget',
};
